export default "__VITE_ASSET__kfnCYxAT__"